/**
 * @description This constant and enum convert the frontend type to a final backend model of the field.
 */
export const RealFieldType = {
	Unknown: 0,
	Text: 1,
	Pushbutton: 2,
	Checkbox: 3,
	Radiobutton: 4,
	Choice: 5,
	Signature: 6,
	Parent: 7,
} as const;

export type RealFieldType = (typeof RealFieldType)[keyof typeof RealFieldType];
/* -------------------------------------------------------------------------- */
export const InternalPdfFieldType = {
	GPS: 'GPS',
	dateField: 'dateField',
	checkBox: 'checkBox',
	image: 'image',
	textBox: 'textBox',
	signature: 'signature',
} as const;
export type InternalPdfFieldType = (typeof InternalPdfFieldType)[keyof typeof InternalPdfFieldType];

/* -------------------------------------------------------------------------- */
export const ExternalPdfFieldType = {
	attachment: 'attachment',
	metadata: 'metadata',
	metaTag: 'metaTag',
} as const;

export type ExternalPdfFieldType = (typeof ExternalPdfFieldType)[keyof typeof ExternalPdfFieldType];

/* -------------------------------------------------------------------------- */

export const FieldType = {
	...InternalPdfFieldType,
	...ExternalPdfFieldType,
} as const;

export type FieldType = (typeof FieldType)[keyof typeof FieldType];
/* -------------------------------------------------------------------------- */
export const FieldEditType = {
	...FieldType,
	tags: 'tags',
} as const;

export type FieldEditType = (typeof FieldEditType)[keyof typeof FieldEditType];
